/*
*   table with database for managers connection
*
* appears in <div class="database__main" id="managerbase" data-controller="managerbase"></div>

*/


import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css'
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import {Modal} from "bootstrap"
import mask from 'jquery-mask-plugin'
import datetimepicker from 'jquery-datetimepicker'
import { jsPDF } from "jspdf"
import {Html5QrcodeScanner} from "html5-qrcode"
import * as neffos from "../neffos.min"
import { openAppointmentModal } from '../modules/appointmentModal';
import {fetchStaffs} from "../services/staff";
import {log} from "qrcode/lib/core/galois-field";

export default class extends Controller {
    table;
    WhoIs;
    tableSchedule;
    dataBaseScheduleStart;
    dataBaseScheduleFinish;
    dataBaseScheduleCurrent = new Date();
    fullDoctorList = [];
    filteredDoctorList = [];
    badges = [];
    occupationModal;
    minClientAge = '';
    salonsList = [];
    initialize(){
        super.initialize();

        /* твиги для вывода ячеек времени с разными статусами */
        Twig.twig({
            id: "schedule-item-free", //controller name
            href: "/twig/s-item-free.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-block", //controller name
            href: "/twig/s-item-block.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-busy", //controller name
            href: "/twig/s-item-busy.twig",// loadable twig
            async: false
        });
        Twig.twig({
            id: "schedule-item-offdays", //controller name
            href: "/twig/s-item-offdays.twig",// loadable twig
            async: false
        });
    }
    conn;

    //checking authorization
    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }

    //logout from authorization
    logout(){
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        let nameVar = Twig.twig({ref: "authorization"}).render({});
        $('#authorization').html(nameVar)
    }

    //create a list of doctors in the select
 /*   getDoctorsList(){
        let jsDoctorList = $('#js-doctors-list');

        if(this.fullDoctorList.length === 0){
            this.fullDoctorList = api.doctorList('doctor');
        }

        let user = api.WhoIs();
        let salon = user.StoreCode;

        this.filteredDoctorList = this.fullDoctorList.filter((item)=>{
            return salon.includes(item.StoreCode);
        });

        this.fullDoctorList.forEach((item)=>{
            let name = item.Name.replace(/(\S+) (\S{1})(\S+) (\S{1})(\S+)/, "$1 $2.$4.");

            if (salon.includes(item.StoreCode)){
                jsDoctorList.append('<option value="'+item.StaffID+'" selected="selected">'+name+' ('+item.StoreCode+')</option>');
            } else {
                jsDoctorList.append('<option value="'+item.StaffID+'">'+name+' ('+item.StoreCode+')</option>');
            }
        });

/!*       jsDoctorList.select2({
           placeholder: 'Нажмите, чтобы выбрать врача/врачей',

       });


        self = this;
        jsDoctorList.on("select2:select", function (e) {
            let index = self.fullDoctorList.findIndex(object => {
                return object.StaffID === Number(e.params.data.id);
            });
            self.filteredDoctorList.push(self.fullDoctorList[index]);
            let column  = self.tableSchedule.column(index +1).visible(true);
        });


        jsDoctorList.on("select2:unselect", function (e) {

            const index = (self.fullDoctorList.findIndex(object => {
                return object.StaffID === Number(e.params.data.id);
            }))
            let column  = self.tableSchedule.column(index +1).visible(false);
        });*!/
    };*/

   /* filteredChangeDoctorList(){
        let inFilter;
        let inIndex;
        self = this;
        this.fullDoctorList.forEach((item, index)=>{
            inIndex = index;
            inFilter = this.filteredDoctorList.findIndex((object)=>{
                return object.StaffID === item.StaffID
            })
            if (inFilter === -1){
                let column  = self.tableSchedule.column(inIndex +1).visible(false);
            }

        })
    }*/

    // data current
    async buildTableSchedule(){
        $.fn.dataTable.ext.errMode = 'none';
        self =  this;

        //устанвливаем дефолтно текущий день
        this.dataBaseScheduleStart = new Date();
        this.dataBaseScheduleStart.setDate(this.dataBaseScheduleStart.getDate() - 1);
        this.dataBaseScheduleStart.setHours(10);
        this.dataBaseScheduleStart.setMinutes(0);
        this.dataBaseScheduleStart.setSeconds(0);

        this.dataBaseScheduleFinish = new Date();
        this.dataBaseScheduleFinish.setDate(this.dataBaseScheduleFinish.getDate()  + 13);
        this.dataBaseScheduleFinish.setHours(20);
        this.dataBaseScheduleFinish.setMinutes(0);
        this.dataBaseScheduleFinish.setSeconds(0);



        //фильтруем докторов: только те, которые пришиты к салону текущего юзера
        this.fullDoctorList = api.doctorList('doctor');


        let user = api.WhoIs();
        let salon = user.StoreId;
        this.filteredDoctorList = this.fullDoctorList.filter((item) => {
            for (let k in item.WorkScheduleNew) {
                if (k.includes('week')) {
                    for (let w in item.WorkScheduleNew[k]) {
                        for (let d in item.WorkScheduleNew[k][w]) {
                            if (Number(item.WorkScheduleNew[k][w].store_id) === salon) {
                                item.currentSalonId = salon;
                                return true
                            }
                        }
                    }
                }
            }
            // return salon.includes(item.StoreCode);

            return false
        });
        console.log('this.filteredDoctorList',this.filteredDoctorList)

        this.tableSchedule = $('#databaseMySchedule').DataTable({
            language: {
                url: 'data/dataTables.ru.json'
            },
            fixedHeader: false,
            lengthChange: false,
            searching: false,
            paging: false,
            info: false,
            bAutoWidth: false,
            //scrollCollapse: true,
            //scrollY: 300,
            deferRender:    true,
            scroller:       false,
            serverSide: true,
            processing: true,
/*            initComplete: function (){
                self.filteredChangeDoctorList();
            },*/
            ajax: {
                url: global.api_url + '/schedule/datatable',
                headers: {'Authorization': 'Bearer '+ sessionStorage.getItem('token')},
                type: 'post',
                data: (data)=>{

                    data.Filter = {
                        'positivId': '82',
                        'interval': '30 minute', //1 hour
                        'start': Math.trunc(this.dataBaseScheduleStart.getTime() / 1000).toString(),
                        'finish': Math.trunc(this.dataBaseScheduleFinish.getTime() / 1000).toString(),
                    };

                    return JSON.stringify(data);
                },
                contentType: "application/json",
                error: (error)=>{
                    console.debug(error);
                }
            },
            columns: await global.globalFuncs.ScheduleTable.getColumnsDatatable(Twig,self.filteredDoctorList),
            drawCallback: global.globalFuncs.ScheduleTable.drawCallback
        });

    }


    getPatientInfo(event){
        if (event.params.customerid !== null){
            let patient = api.searchPatient(event.params.customerid);
            let patientDateBirth = new Date(patient.ClientDateBirth).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
            $('#patientDateBirth-'+event.params.id).text(patientDateBirth);
            $('#patientClientAge-'+event.params.id).text(patient.ClientAge);
        }
    }

    blockTime(event){
        let blockTimeData = $($('#blockTime-'+event.params.id)[0]).serializeObject();
        if (blockTimeData.reason === ''){
            $('#blockTime-'+event.params.id+' label').append('<strong id="blockTimeAlert-'+event.params.id+'" style="color: red; display: inline-block; padding-left: 10px">заполните поле!</strong>');
            setTimeout(function() {
                    $('#blockTimeAlert-'+event.params.id).remove();
                },
                5000);
        } else {
            let result = api.blockTime(blockTimeData);
            $('#check-'+event.params.id).prop('checked', false);
            if (result.Status === 200 ){
                this.tableSchedule.row(event.params.row).invalidate().draw();
            }
        }

    }

    setPrepaid(event){
        let prepaid = $($('#prepaidForm-'+event.params.id)[0]).serializeObject();
        if (prepaid.sum === ''){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">заполните поле!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }
        const hasOnlyDigits = (v) => /^\d+$/.test(v);

        if(!hasOnlyDigits(Number(prepaid.sum))){
            $('#prepaidFormAlert-'+event.params.id).remove();
            $('#prepaidForm-'+event.params.id).append('<strong id="prepaidFormAlert-'+event.params.id+'" style="color: red; display: flex; width: 100%; padding:3px 0 0">только цифры!</strong>');
            setTimeout(function() {
                    $('#prepaidFormAlert-'+event.params.id).remove();
                },
                5000);
            return
        }

        let result = api.setPrepaid(prepaid.orderId, prepaid.sum);
        $('#check-'+event.params.id).prop('checked', false);
        if (result.Status === 200 ){
            this.tableSchedule.row(event.params.row).invalidate().draw();
        }
    }

    isApproved(event){
        let result = api.isApproved(event.params.dataid);
        if (result.Status === 200 ){
            this.tableSchedule.row(event.params.row).invalidate().draw();
        }
    }

    cancelOrder(event){
        let cancelOrderData = $($('#canselOrderForm-'+event.params.id)[0]).serializeObject();
        if (cancelOrderData.canselReason === ''){
            $('#canselOrderForm-'+event.params.id+' .canselOrder__title').append('<strong id="blockTimeAlert-'+event.params.id+'" style="color: red; display: inline-block; padding-left: 10px">заполните поле!</strong>');
            setTimeout(function() {
                    $('#blockTimeAlert-'+event.params.id).remove();
                },
                5000);
            return
        }
        let result = api.cancelOrder(cancelOrderData.orderId,cancelOrderData.canselReason);
        $('#check-'+event.params.id).prop('checked', false);
        if (result.Status === 200 ){
            this.tableSchedule.row(event.params.row).invalidate().draw();
        }

    }


    openAppointmentModal(event){
        openAppointmentModal.call(this, event);
    }


    closeNote(event){
        $('#check-'+event.params.id).prop('checked', false);
    }

    infoMySalonSchedule(){
        let start = this.dataBaseScheduleStart.toLocaleDateString('ru-KZ');
        let finish = this.dataBaseScheduleFinish.toLocaleDateString('ru-KZ');
        $('#collapseMySalonSchedule').html(global.WhoIs.StoreCode+' с '+start.replace(/(\d+).(\d+).(\d+)/, "$1.$2")+' по '+finish.replace(/(\d+).(\d+).(\d+)/, "$1.$2")+' ');

    }

    async connectNote() {
        const wsURL = global.wsURL;

        try {
            this.conn = await neffos.dial(wsURL, {
                default: { // "default" namespace.
                    _OnNamespaceConnected: function (nsConn, msg) {
                        if (nsConn.conn.wasReconnected()) {
                            console.debug('wasReconnected')
                        }
                        console.debug('connected')
                    },
                    _OnNamespaceDisconnect: function (nsConn, msg) {
                        console.debug('Disconnect')
                    },
                    onAddOccupation:function (nsConn, msg) { // добавлена запись
                        self.onAddOccupation(nsConn, msg);
                    },
                    onBlockOccupation:function (nsConn, msg) { // добавлен блок
                        self.onBlockOccupation(nsConn, msg)
                    },
                    onDeleteOccupation:function (nsConn, msg) { // удалена запись/блок
                        self.tableSchedule.ajax.reload(null,false);
                    },
                }
            });

            this.conn.connect("default");
        } catch (err) {
            console.log(err);

        }
    }
    onAddOccupation(nsConn, msg){
        let userAllData = JSON.parse(msg.Body);
        let userInfo = userAllData.request;
        let userRecordInfo = userAllData.result;
        let basicTime = Number(userInfo.orderDateTimeFrom);
        let basicTimeEnd = Number(userInfo.orderDateTimeTo);
        for(let t = basicTime;t < basicTimeEnd; t+= 30 * 60 * 1000){
            let cellTimeItemID = 'cell-'+userInfo.doctorId+'-'+t;
            let currentDoctorSalon = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-currentDoctorSalon');
            let itemName = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-doctorName');
            let metaRow = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-metaRow');
            let unitId = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-unitId');

            let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

            let doctorDate = new Date(basicTime).getDate();
            let monthName = months[new Date(basicTime).getMonth()];
            let diagnosticType = '';

            diagnosticType = global.globalFuncs.DiagnosticTypes.getDiagnosticTypeTitle(userInfo.orderServiceList)

            let doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
            let doctorScheduleLargeComment = '';
            let doctorScheduleVisit = "";
            let doctorScheduleWhoWrote = "";
            let doctorScheduleWhoWroteStatus = '';
            let doctorScheduleComeFrom = '';
            let doctorSchedulePatientAge = '';
            let clientAge = '';


            let userInfoInfo = userInfo.info;
            for (let key in userInfoInfo) {
                let userInfoInfoData = userInfoInfo[key];
                if (key === 'comment'){
                    if (userInfoInfoData === ''){
                        doctorScheduleComment = "<span class='form-text text-muted'>нет комментария</span>";
                    } else {
                        doctorScheduleComment = userInfoInfoData.replaceAll('|', '<br>');
                        if (doctorScheduleComment.length > 50){
                            doctorScheduleLargeComment = 'datatableDoctorOrderInfo__comment--large'
                        }
                    }

                }
                if (key === 'visit'){
                    doctorScheduleVisit = global.globalFuncs.ScheduleVisit.getVisitTypeTitle(userInfoInfoData) ||  userInfoInfoData
                }
                if (key === 'doctor'){
                    doctorScheduleWhoWroteStatus = 'врач';
                    doctorScheduleWhoWrote = userInfoInfoData;
                    doctorScheduleComeFrom = 'салон'
                }
                if (key === 'manager'){
                    doctorScheduleWhoWroteStatus = 'менеджер';
                    doctorScheduleWhoWrote = userInfoInfoData;
                    doctorScheduleComeFrom = 'салон'
                }
                if (key === 'ref'){
                    doctorScheduleWhoWroteStatus = 'пациент';
                    doctorScheduleComeFrom = userInfoInfoData
                }
                if (key === 'clientAge') {
                    doctorSchedulePatientAge = userInfoInfoData;
                    clientAge = userInfoInfoData;
                }

            }
            //let dataID = userRecordInfo.object[0];
            let dataID = '';
            for (let key in userRecordInfo.object){
                if (userRecordInfo.object[key] === 'new id'){
                    dataID = Number(key);
                }
            }

            let doctorTimeHours = new Date(t).toLocaleTimeString(
                "ru-RU",
                {
                    minute:'2-digit',
                    hour:'2-digit'
                });
            let orderDateDayToUser = new Date(t).toLocaleDateString(
                'ru-RU',
                {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            let orderStart = new Date(basicTime).toLocaleTimeString(
                'ru-KZ',
                {
                    hour: "2-digit",
                    minute: "2-digit"
                });
            let orderEnd = new Date(basicTimeEnd).toLocaleTimeString(
                'ru-KZ',
                {
                    hour: "2-digit",
                    minute: "2-digit"
                });
            let prepayAmountText = "";
            let timeItemID = userInfo.doctorId+'-'+t;
            //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
            let timePassed = "";
            let timePassedDisabled = "";
            if(new Date() > new Date(t)){
                timePassed = 'time_passed';
                timePassedDisabled = 'disabled="disabled"'
            }
            let controllerName = $('.database__main').attr("id");

            let content = Twig.twig({ref: "schedule-item-busy"}).render({
                'clientsCustomerID': "",
                'controllerName': controllerName,
                'patientClientAge': clientAge,
                'clientName': userInfo.clientName+' '+userInfo.clientSurname+' '+userInfo.clientPhone,
                'patientDateBirth': userInfo.clientDateBirth,
                'currentDoctorSalon': currentDoctorSalon,
                'dataIsApproved': 'isApproved',
                'dataID': dataID,
                'diagnosticType': diagnosticType,
                'doctorDate': doctorDate,
                'doctorScheduleComment':doctorScheduleComment,
                'doctorScheduleLargeComment': doctorScheduleLargeComment,
                'doctorScheduleVisit':doctorScheduleVisit,
                'doctorTimeHours': doctorTimeHours,
                'isApprovedText':'подтвержден',
                'itemName': itemName,
                'metaRow': metaRow,
                'monthName': monthName,
                'orderDateDayToUser': orderDateDayToUser,
                'orderStart':orderStart,
                'orderEnd': orderEnd,
                'prepayAmountText':prepayAmountText,
                'statusDoctorClass': 'isApproved',
                'switchStatus': 'checked',
                'timeItemID':timeItemID,
                'timePassed': timePassed,
                'timePassedDisabled': timePassedDisabled,
                'unitId': unitId,
            });

            $('#'+cellTimeItemID).html(content);
        }
    }

    onBlockOccupation(nsConn, msg){
        let userAllData = JSON.parse(msg.Body);
        let userInfo = userAllData.request;
        let userRecordInfo = userAllData.result;
        let basicTime = Number(userInfo.orderDateTimeFrom);
        let basicTimeEnd = Number(userInfo.orderDateTimeTo);
        let cellTimeItemID = 'cell-'+userInfo.doctorId+'-'+basicTime;
        let currentDoctorSalon = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-currentDoctorSalon');
        let itemName = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-doctorName');
        let metaRow = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-metaRow');
        let unitId = $('#'+cellTimeItemID+'>.datatableDoctorOrderBox').attr('data-unitId');

        let months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
            "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

        let doctorDate = new Date(basicTime).getDate();
        let monthName = months[new Date(basicTime).getMonth()];
        let dataID = '';
        for (let key in userRecordInfo.object){
            if (userRecordInfo.object[key] === 'new id'){
                dataID = Number(key);
            }
        }
        let doctorTimeHours = new Date(basicTime).toLocaleTimeString(
            "ru-RU",
            {
                minute:'2-digit',
                hour:'2-digit'
            });
        let orderDateDayToUser = new Date(basicTime).toLocaleDateString(
            'ru-RU',
            {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        let orderDateFromTimeToUser = new Date(basicTime).toLocaleTimeString(
            'ru-KZ',
            {
                hour: "2-digit",
                minute: "2-digit"
            });
        let orderDateToTimeToUser = new Date(basicTimeEnd).toLocaleTimeString(
            'ru-KZ',
            {
                hour: "2-digit",
                minute: "2-digit"
            });
        let timeItemID = userInfo.doctorId+'-'+basicTime;
        let dataReason = userInfo.reason;
        let controllerName = $('.database__main').attr("id");

        //считаем прошедшее время - для класса. если time_passed - ячейка времени НЕ активна
        let timePassed = "";
        let timePassedDisabled = "";
        if(new Date() > new Date(basicTime)){
            timePassed = 'time_passed';
            //timePassedDisabled = 'disabled="disabled"'
        }
        let content = Twig.twig({ref: "schedule-item-block"}).render({
            'clientsCustomerID': "",
            'controllerName': controllerName,
            'currentDoctorSalon': currentDoctorSalon,
            'doctorDate': doctorDate,
            'dataID': dataID,
            'doctorTimeHours': doctorTimeHours,
            'itemName': itemName,
            'monthName': monthName,
            'orderDateDayToUser': orderDateDayToUser,
            'orderDateFromTimeToUser': orderDateFromTimeToUser,
            'orderDateToTimeToUser': orderDateToTimeToUser,
            'dataReason': dataReason,
            'timeItemID':timeItemID,
            'timePassed': timePassed,
            'unitId': unitId,
        });
        $('#'+cellTimeItemID).html(content);
    }

    connect(){

        // we turn to twig, indicate which controller to use, inside we transfer the data
        let content = Twig.twig({ref: "doctors-schedule"}).render({});

        let token = sessionStorage.getItem('token');
        if (token === null ){
            this.logout();
        }

         //specify the block and display the contents of the twig in it
        $('#doctors-schedule').html(content);

        if (WhoIs.Type === 'office'){
            this.clearFilter();
        }

        /* sheduler */
        this.StoreCode = WhoIs.StoreCode;
        this.buildTableSchedule();
        this.infoMySalonSchedule();

        //salon list
        // this.salonsList = api.salonsList();

        //server
        this.connectNote();
     }

    disconnect(){
        this.conn.close();
    }
}
